import {
  Component,
  OnInit,
  Inject,
  Input,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { AuthService } from "../auth/auth.service";
import { UserService } from "../core/services/v2/user.service";
declare var $: any;

@Component({
  selector: "app-headernav",
  templateUrl: "./headernav.component.html",
  styleUrls: ["./headernav.component.scss"],
})
export class HeadernavComponent implements OnInit {
  @Input() hideMenu: Boolean = false;
  @ViewChild("contactSideBar", { static: false }) contactSideBar: ElementRef;

  constructor(
    @Inject(DOCUMENT) private document,
    private router: Router,
    public authService: AuthService,
    private userService: UserService
  ) {
    let result = this.authService.isLoggedIn();

    if (result) {
      this.RedirectAccorndilyUsersRole();
    }
  }

  ngOnInit() {
    // Mobile Menu //
    let hamburger = document.querySelector(".hamburger");
    let closeBtn = document.querySelector(".close");
    let menuList = document.querySelector(".menu-list");
    $(hamburger).click('on', function () {
      $(menuList).addClass("active");
      $("body").addClass("overflow--hidden");
    });
    $(closeBtn).click('on', function () {
      $(menuList).removeClass("active");
      $("body").removeClass("overflow--hidden");
    });
    // Mobile Menu //

    // Message Box //
    let messageBtn = document.querySelector("#messageBtn");
    let messageClose = document.querySelector("#messageBox--close");
    let messageBox = document.querySelector(".messageBox");
    $(messageBtn).click('on', function () {
      $(messageBox).addClass("messageBox--show");
      $("body").addClass("overflow--hidden");
    });
    $(messageClose).click('on', function () {
      $(messageBox).removeClass("messageBox--show");
      $("body").removeClass("overflow--hidden");
    });
    // Message Box //
  }


  private goToPage(page: string): void {
    this.router.navigate([page]);
  }

  redirectContact() {
    this.goToPage("/contactus");
  }

  out() {
    this.goToPage("/home");
  }

  redirectToSignUp() {
    this.goToPage("/Signup");
  }

  async redirectLogin() {
    this.router.navigate(['/welcome-login']);

    // let result = await this.authService.isLoggedIn();

    // if (result) {
    //   this.RedirectAccorndilyUsersRole();
    // } else {
    //   this.document.location.href = `/Session/SignIn?redirectUrl=/app/userhome`;
    // }
  }
  private RedirectAccorndilyUsersRole() {
    this.userService.getUserDetails().subscribe(
      (res) => {
        console.log("us", res);
        if (res) {
          if (res.role == "AHIAdministrator") {
            this.router.navigate(["admin"]);
          } else if (res.role == "CaseManager") {
            this.router.navigate(["casemanager"]);
          } else if (
            res.isGlobalAdministrator ||
            this.userService.rolesRoutedToPhysician.indexOf(res.role) >= 0
          ) {
            // if (res.role == 'Physician' || res.role == 'Midlevel' || res.role == 'Front Desk' || res.role == 'Administrator'
            // || res.role == 'GlobalAdministrator')
            this.router.navigate(["physician"]);
          } else if (res.role == "Patient") {
            this.router.navigate(["patient"]);
          }
          else if (res.role == "Employer") {
              this.router.navigate(["employer"]);
          }
          else if (res.role == "Call Care Coordinator") {
            this.router.navigate(["callcenter"]);
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }
}

